import EntityState from '@/modules/common/store/entityState'
import NewsData from '@/modules/news/domain/newsData'

export default class NewsDataState extends EntityState<NewsData> {
  itemsLastMonth: NewsData[] = []
  parametersLastMonth: any
}
